import React, { Children, useState } from "react";
import TextField from "@mui/material/TextField";

// import JS files
import MuiTheme from "./MuiTheme";

// import Others files

const ltrStyle = {
  direction: "ltr",
};
const rtlStyle = {
  direction: "rtl",
};

const MuiTextArea = ({
  id,
  label,
  variant,
  size,
  onChange,
  value,
  isLTR,
  type,
  disabled,
  defaultValue,
  placeholder,
}) => {
  let windowWidth = window.screen.width;

  return (
    <>
      <MuiTheme>
        <TextField
          id={id}
          label={label}
          variant={variant}
          style={isLTR ? ltrStyle : rtlStyle}
          sx={{ width: "100%", input: { textAlign: "center" } }}
          size={size}
          value={value}
          onChange={onChange}
          type={type}
          disabled={disabled}
          defaultValue={defaultValue}
          placeholder={placeholder}
          rows={2}
          multiline
        />
      </MuiTheme>
    </>
  );
};

export default MuiTextArea;
